import { api } from "../../api/api";
import { properties } from "../../constants/Propertise";

const SET_FORGOTPASSWORD_PENDING = 'SET_FORGOTPASSWORD_PENDING';
const SET_FORGOTPASSWORD_SUCCESS = 'SET_FORGOTPASSWORD_SUCCESS';
const SET_FORGOTPASSWORD_ERROR = 'SET_FORGOTPASSWORD_ERROR';

export function forgotPassword(forgotPasswordData, otp) {
    return dispatch => {
        dispatch(setForgotPasswordPending(true));
        let validatOtpUrl = `${process.env.PUBLIC_URL}forgotPassword/validateOTP/${otp}`;
        api
            .post(validatOtpUrl, forgotPasswordData)
            .then(result => {
                if (result.data !== "undefined") {
                    if (result.status === 200) {
                        if (result.data !== "OTP Is Valid!") {
                            dispatch(setForgotPasswordSuccess(true, result.data));
                        } else {
                            dispatch(setForgotPasswordError(result.data));
                        }
                    } else {
                        dispatch(setForgotPasswordError(properties.globalErrorMessage));
                    }
                } else {
                    dispatch(setForgotPasswordError(properties.globalErrorMessage));
                }
            })
            .catch(error => {
                dispatch(setForgotPasswordError(properties.userLoginError));
            });
    }
}

function setForgotPasswordPending(isForgotPasswordPending) {
    return {
        type: SET_FORGOTPASSWORD_PENDING,
        isForgotPasswordPending
    };
}

function setForgotPasswordSuccess(isForgotPasswordSuccess, data) {
    return {
        type: SET_FORGOTPASSWORD_SUCCESS,
        isForgotPasswordSuccess,
        forgotPasswordMessage: data
    };
}

function setForgotPasswordError(forgotPasswordApiError) {
    return {
        type: SET_FORGOTPASSWORD_ERROR,
        forgotPasswordApiError
    }
}

export default function forgotPasswordReducer(state = {
    isForgotPasswordSuccess: false,
    isForgotPasswordPending: false,
    forgotPasswordError: false,
    forgotPasswordApiError: false,
    forgotPasswordMessage: ''
}, action) {
    switch (action.type) {
        case SET_FORGOTPASSWORD_PENDING:
            return Object.assign({}, state, {
                isForgotPasswordPending: action.isForgotPasswordPending,
                isForgotPasswordSuccess: false,
                forgotPasswordError: false,
                forgotPasswordApiError: false
            });

        case SET_FORGOTPASSWORD_SUCCESS:
            return Object.assign({}, state, {
                isForgotPasswordSuccess: action.isForgotPasswordSuccess,
                isForgotPasswordPending: false,
                forgotPasswordError: false,
                forgotPasswordApiError: false,
                forgotPasswordMessage: action.forgotPasswordMessage
            });

        case SET_FORGOTPASSWORD_ERROR:
            return Object.assign({}, state, {
                forgotPasswordApiError: action.forgotPasswordError,
                isForgotPasswordPending: false,
                isForgotPasswordSuccess: false,
                forgotPasswordError: true
            });

        default:
            return state;
    }
}